import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import HTMLicon from "../../Assets/Skillicons/html.png";
import CSSicon from "../../Assets/Skillicons/css.png";
import Bootstrapicon from "../../Assets/Skillicons/bootstrap.png";
import Tailwindicon from "../../Assets/Skillicons/tailwaind.png";
import Jsicon from "../../Assets/Skillicons/js-file.png";
import Reacticon from "../../Assets/Skillicons/react.png";
import Muiicon from "../../Assets/Skillicons/metarial ui.png";
import Firebaseicon from "../../Assets/Skillicons/firebase.png";
import Giticon from "../../Assets/Skillicons/github.png";
import Expressicon from "../../Assets/Skillicons/express.png";
import Nodeicon from "../../Assets/Skillicons/node js.png";
import MongoDBicon from "../../Assets/Skillicons/mongodb.png";
import "./Skills.css";

const Skills = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section class="skills container" id="skills">
      <div data-aos="fade-down" data-aos-duration="2000">
        <h1 class="heading">
          {" "}
          <span>My</span> Skills
        </h1>
      </div>

      <div class="row">
        <div class="counter">
          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={HTMLicon} alt="" srcset="" />
              <h3>HTML</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={CSSicon} alt="" srcset="" />
              <h3>CSS</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Bootstrapicon} alt="" srcset="" />
              <h3>Bootstrap</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Tailwindicon} alt="" srcset="" />
              <h3>Tailwind CSS</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Jsicon} alt="" srcset="" />
              <h3>JavaScript</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Reacticon} alt="" srcset="" />
              <h3>React Js</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Muiicon} alt="" srcset="" />
              <h3>Material UI</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Firebaseicon} alt="" srcset="" />
              <h3>Firebase</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Giticon} alt="" srcset="" />
              <h3>GitHub</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Expressicon} alt="" srcset="" />
              <h3>Express Js</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={Nodeicon} alt="" srcset="" />
              <h3>Node Js</h3>
            </div>
          </div>

          <div
            data-aos="zoom-in-up"
            data-aos-duration="2000"
            data-aos-anchor-placement="center-bottom"
          >
            <div class="box">
              <img src={MongoDBicon} alt="" srcset="" />
              <h3>MongoDB</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
